import React from 'react';
import { Linking, Alert, Platform } from 'react-native';
import { Button, ButtonText } from '@/components/ui/button';
import { Pressable } from '@/components/ui/pressable';
import { useSelector } from 'react-redux';
import { studioVersion } from '@/studio/algorithms_and_functions/studioVersion';
import { IconMC } from '../media/IconsV2';

export default function OpenIssueButton({ navigation, label, icon, title, description }) {
    const user = useSelector((state) => state.user);
    const server = useSelector((state) => state.server);
    const commit = useSelector((state) => state.commit || '-');
    
    return icon ? (
        <Pressable
            onPress={() =>
                openGiteaIssue({
                    title: title,
                    description: description,
                    version: studioVersion,
                    commit: commit,
                    user: user.mail,
                    server: server.url,
                    navigation: navigation
                })
            }
            className="rounded-full border-2 border-error-600 p-[1.5px] bg-secondary-50 self-end">
            <IconMC className="text-4xl text-error-600" name={icon} size='md'/>
        </Pressable>
    ) : (
        <Button
            size="lg"
            className={`px-2 w-full bg-error-600 hover:bg-error-700 active:bg-error-800`}
            onPress={() =>
                openGiteaIssue({
                    title: title,
                    description: description,
                    version: studioVersion,
                    commit: commit,
                    user: user.mail,
                    server: server.url,
                    navigation: navigation
                })
            }>
            <ButtonText className="font-normal text-secondary-50">{label}</ButtonText>
        </Button>
    );
}

async function openGiteaIssue({ title = ' ', description = '...', commit = '', version = '', user = '', server = '', navigation }) {
    const navState = navigation.getState()
    console.log('XXX', navState)
    const screen = navState.routes[navState.index].name

    const giteaBaseUrl = 'https://git.bos-connect.de/inacoach/app/issues/new';
    const body = `
## Beschreibung

${description}

## Systeminfo
Screen: ${screen}
User: ${user}
Server: ${server}
Version: [${version}](graph?branch=refs%2Ftags%2F${version})
Commit: ${commit}
Plattform: ${Platform.OS}${Platform.OS === 'web' ? `\nBrowser: ${navigator.userAgent || navigator.vendor || window.opera}` : ''}
`.trim();

    // const issueUrl = `${giteaBaseUrl}?project=${Platform.OS === 'web' ? '6' : '5'}&title=[${commit}]${title}&body=${body}`;
    // const issueUrl = `${giteaBaseUrl}?project=${Platform.OS === 'web' ? '6' : '5'}&title=[${commit}]${title}&body=${encodeURIComponent(body)}`;

    const issueUrl =
        `${giteaBaseUrl}?` +
        [
            ['project', Platform.OS === 'web' ? '6' : '5'],
            ['title', `[${commit}]${title}`],
            ['body', body]
        ]
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');

    console.log('LINK', issueUrl);

    try {
        const supported = await Linking.canOpenURL(issueUrl);

        if (!supported) {
            Alert.alert('Fehler', 'Der Issue-Link kann nicht geöffnet werden.');
            return;
        }
        await Linking.openURL(issueUrl);
    } catch (error) {
        Alert.alert('Fehler', 'Gitea konnte nicht geöffnet werden.');
        console.error(error);
    }
}
